import { Select, Button, notification } from 'antd'
import React, { useEffect, useState, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import styles from './RowUserAcces.module.css'
import { BuilderContext } from '../../../../pages/Sandbox/components/store/store.Builder'
import { ReadOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'

const { Option } = Select

notification.config({
  placement: 'top',
  duration: 3,
  top: 50,
})

const RowUserAcces = observer(
  ({ user, onEditUser, onDeleteUser, showRights }) => {
    const builderContext = useContext(BuilderContext)
    const [selectedOption, setSelectedOption] = useState(user.permission)
    const initials = user.full_name
      ? user.full_name
          .split(' ')
          .map((name) => name.charAt(0))
          .join('')
          .toUpperCase()
      : ''

    const handleOptionChange = async (value) => {
      setSelectedOption(value)
      try {
        const formData = {
          permission: value,
          form_url_code: builderContext.url_code,
          user_username: user.username,
          user_first_name: user.first_name,
          user_last_name: user.last_name,
        }
        await onEditUser(formData, user.id)
        notification.success({ message: 'Droits modifiés avec succès' })
      } catch (error) {
        notification.error({
          message:
            "Erreur lors de la modification des droits de l'utilisateur.",
        })
      }
    }

    const handleDeleteUser = async () => {
      try {
        await onDeleteUser(user.id)
        notification.success({ message: 'Utilisateur supprimé avec succès' })
      } catch (error) {
        notification.error({
          message: "Erreur lors de la suppression de l'utilisateur.",
        })
      }
    }

    useEffect(() => {
      setSelectedOption(user.permission)
    }, [user.permission])

    return (
      <div className={styles.row}>
        <div className={styles.avatar}>{initials}</div>

        <div className={styles.container__informations}>
          <div className={styles.fullName}>{user.full_name || ''}</div>
          {/* Ne plus afficher l'UID */}
          {/* <div className={styles.login}>{user.username}</div> */}
          <div className={styles.email}>{user.email}</div>
        </div>

        <div className={styles.add}>
          {showRights ? (
            <Select
              defaultValue={user.permission}
              value={selectedOption}
              onChange={handleOptionChange}
              dropdownRender={(menu) => (
                <div>
                  {React.cloneElement(menu, {
                    style: { minWidth: '160px' },
                  })}
                </div>
              )}
            >
              <Option value="write">
                <span>
                  <EditOutlined style={{ marginRight: '8px' }} />
                  Écriture
                </span>
              </Option>
              <Option value="read">
                <span>
                  <ReadOutlined style={{ marginRight: '8px' }} />
                  Lecture
                </span>
              </Option>
            </Select>
          ) : null}

          <Button
            type="link"
            icon={<DeleteOutlined />}
            onClick={handleDeleteUser}
          />
        </div>
      </div>
    )
  }
)

export default RowUserAcces
